import http from '../util/http';
import store from '@/store';
import { Message } from 'zk-ui';

export const login = (data) => http.post('/account/login', data, {
  assertResult: (res, data) => {
    if (data.code === '0410001') {
      data.result = data.code;
      return true;
    }
    if (data.code === '200') {
      return true;
    }
    if (data.code === '04206') {
      data.result = {
        code: data.code,
        msg: data.msg
      };
      return true;
    }
  }
});

/**
 * @param errorCodes: 需要自定义处理的错误码
 */ 
export const loginWithVerifyCode = (data, errorCode = []) => http.post('/account/anonymous/login-code', data, {
  assertResult: (res, data) => {
    if (data.code === '0410001') {
      data.result = data.code;
      return true;
    }
    if (data.code === '200') {
      return true;
    }
    if (['04206', ...errorCode].includes(data.code)) {
      data.result = {
        code: data.code,
        msg: data.msg
      };
      return true;
    }
  }
});

export const logout = () => http.post('/account/logout', {}, { showError: false });

export const checkEmail = (orgEmail) => http.post('/account/check-email', { orgEmail });

const assertTemporaryUserInfo = async (response, data) => {
  // 没加入组织，生成临时用户信息
  if (response.data?.code === '0418'){
    const userId = 'temporary0418';
    response.data = { userId };
    return true;
  }
  if (data.code === '200'){
    return true;
  }
  await store.dispatch('user/clear');
  return false;
};

export const getCurrentUserInfo = (token) => http.post('/account/user-info', {}, {
  showError: false,
  headers: {
    accesstoken: token
  },
  assertResult: assertTemporaryUserInfo
});

/**
 * 获取用户聚合信息：用户信息、组织信息
 * @param token
 * @returns {AxiosPromise | Promise<any>}
 */
export const getUserAssembleInfo = (token) => {
  return http.post('/account/user-org-assemble', {}, {
    showError: false,
    headers: {
      accesstoken: token
    },
    assertResult: async (response, data) => {
      // 没加入组织，生成临时用户信息
      if (response.data?.code === '0418'){
        const userId = 'temporary0418';
        response.data = { userInfo: { userId }, orgInfo: {} };
        return true;
      }
      if (data.code === '200') {
        return true;
      }
      if (data?.code === '0410020') {
        Message({
          message: data.msg,
          type: 'error',
          duration: 2000
        });
      }
      await store.dispatch('user/clear');
      return false;
    }
  });
};

/**
 * 使用token换取临时票据
 * @param token
 * @returns {AxiosPromise | Promise<any>}
 */
export const exchangeTicketOfToken = token => http.post('/tickets', {}, {
  showError: false,
  headers: {
    accesstoken: token
  }
});

/**
 * 使用临时票据换取token
 * @param ticket
 * @returns {AxiosPromise | Promise<any>}
 */
export const exchangeTokenOfTicket = ticket => http.get('/tickets/get-token', { ticket });

/**
 * 获取当前产品线订购权益信息
 * @returns {}
 */
export const getOrgProductRights = (data, token) => http.post('/product/get/org-product-right', data, {
  headers: {
    accesstoken: token
  }
});

export async function checkStorage(data) {
  return http.post('/product/get/current-right', data, {
    assertResult: (res, data) => {
      if (data.code === '1610') {
        data.result = data.code;
        return true;
      }
      if (data.code === '200') {
        return true;
      }
    }
  });
}

// export function createUserInitIssue(issueTypeCode){
//   return http.get(`/account-preferences/v2/create-user-init-issue?issueTypeCode=${issueTypeCode}`);
// }

export async function habitRecord(data) {
  return http.post('/account/habit-record', data);
}

export async function getHabitRecord(data) {
  return http.post('/account/habit-query', data);
}